export default __webpack_public_path__ + "static/social-crimen-tasas-ab43db85411eb3a8fae8df9bc0378e05.png";